// Total máquinas: Suma de las lecturas de máquinas (incluyendo billares).
// Billares semana: Suma billares del cierre diario de toda la semana (MovEc).
// Arcade semana: Total máquinas – Billares Semana.
// Maq. Cambios: Total ingresos de máquinas de cambio (por lecturas).
// Ingresos Arcade: Arqueo total de las máquinas de arcade
// Ingresos Arcade 2: Arqueo operadora
//

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import { modifyArqueo, modifyBanco2 } from '../../actions/cierre_semanal_actions';
import { openDialog } from '../../actions/index';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Paper, Typography, } from '@material-ui/core';
//import { Tooltip, Fade } from '@material-ui/core';

import { postData } from '../../dataLib';

import FloatNumberFormatInput from '../../components/float_number_input_formatter';

const styles = theme => ({
    root: {
        margin: '8px 0',
        width: '280',
    },
    paperConcepto: {
        padding: 0,
        margin: 8,
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
    },
    titleIngresos: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'white',
        backgroundColor: 'black',
        padding: '4px 2px 4px 12px',
    },
    paperItem: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 25px',
        boxShadow: 'none',
    },
    containeritems: {
        width: '100%',
        margin: '8px auto',
    },
    label: {
        maxWidth: '50%',
        fontSize: 13
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 11,
    },
    input: {
        width: 75,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    banco: {
        margin: '0 5px',
        maxWidth: 70,
    },
    button: {
        padding: '0 5px',
        backgroundColor: theme.palette.secondary.light,
        color: 'inherit',
        borderRadius: 0,
        fontSize: 12,
        width: '35%',
        minWidth: 45,
        height: 40,
        '&:hover': {
            backgroundColor: '#cc8ebf'
        },
        boxShadow: '1px 1px 1px darkgrey',
        overflow: 'hidden'
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class CierreSemanalArcade extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            banco2: 0.0,
            updating: false
        };
    };

    handleImporteChange = (event) => {
        this.setState({ ...this.state, importe: event.target.value });
    };

    onValueChange = (value) => {
        this.props.modifyDatosCierreSemanal({ ...this.props.producto, importe: value });
    };

    // numberWithCommas = num => {
    //     if(!num) return '0.00'
    //     const numDecimals = num.toFixed(2);
    //     return numDecimals.toString().replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // };

    componentDidMount() {
        this.setState({ ...this.state, banco2: this.props.datosCierreSemanal.bancoArcade2 });
    }

    renderItem = (label, value) => {
        const { classes } = this.props;
        return [
            <form key={label + '-label'} >
                <Paper className={classes.paperItem} >

                    <Typography variant="subtitle2" className={classes.label}>
                        {label}
                    </Typography>


                    <TextField
                        key={label + '-value'}
                        className={classes.input}
                        disabled
                        id={label}
                        value={value}
                        InputProps={{
                            classes: { input: classes.inputImporte },
                            inputComponent: FloatNumberFormatInput
                        }}
                        variant="outlined"
                    />

                </Paper>
            </form>
        ];
    };

    handleBanco2Change = (event) => {
        this.setState({ ...this.state, banco2: event.target.value })
    }

    onValueBanco2Change = () => {
        this.props.modifyBanco2(this.state.banco2);
    }

    updateBanco2DB = () => {

        if(this.state.updating === true) return;

        this.setState({ ...this.state, updating: true }, () => {

            var url = 'CierreSemanalDatos/banco2?centro_id=' + this.props.centroDiaSelected.centro.id;
            url += '&date=' + this.props.centroDiaSelected.dia;
            url += '&importe=' + this.state.banco2;
            postData(
                url,
                () => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'banco actualizado'
                    }, 'banco2_actualizado', false, 'sm');
                    this.setState({ ...this.state, updating: false });
                },
                () => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'error actualizando banco'
                    }, 'banco2_actualizado_error', false, 'sm');
                    this.setState({ ...this.state, updating: false });
                },
                {},
                this.props.user
            );
        });
    }

    renderBanco = () => {
        const { classes } = this.props;
        return [
            <form key={'banco'}>
                <Paper className={classes.paperItem} >

                    <Typography key={'banco-label'} variant="subtitle2" className={classes.label}>Ingresos Arcade</Typography>

                    <TextField
                        key={'banco-value'}
                        className={`${classes.input} ${classes.banco}`}
                        id="banco"
                        value={this.props.datosCierreSemanal.bancoArcade}
                        disabled
                        InputProps={{
                            readOnly: true,
                            classes: { input: classes.inputImporte },
                            inputComponent: FloatNumberFormatInput
                        }}
                        variant="outlined"
                    />

                    <Button
                        key={'banco-button'}
                        className={classes.button}
                        color="primary"
                        onClick={() => this.props.openDialog('Arqueo', {
                            cajaId: this.props.datosCierreSemanal.cajaIDcambio,
                            //cajaId: this.props.datosCierreSemanal.cajaIDarcade,
                            okHandler: (total) => {
                                this.props.modifyArqueo(total);
                            },
                            disabled: this.props.datosCierreSemanal.isSemanaCerrada
                        }, uuidv4(), true, "xs")}
                    >Arqueo
                    </Button>

                </Paper>

                <Paper className={classes.paperItem} hidden={!this.props.user || this.props.centroDiaSelected.centro.reopa === 31262 || !['25', '795'].includes(this.props.user.profile.sub)}>

                    <Typography key={'banco-label-2'} variant="subtitle2" className={classes.label}>Ingresos Arcade 2</Typography>

                    <TextField
                        key={'banco-value-2'}
                        className={`${classes.input} ${classes.banco}`}
                        id="banco"
                        value={this.state.banco2}
                        onChange={(event) => this.handleBanco2Change(event)}
                        onBlur={(event) => this.onValueBanco2Change(event.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') { e.preventDefault(); this.onValueBanco2Change(e.target.value) };
                        }}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}

                        variant="outlined"
                    />
                    <Button
                        key={'banco-button-2'}
                        className={classes.button}
                        color="primary"
                        onClick={() => {
                            this.updateBanco2DB();
                        }}
                    >Actualizar
                    </Button>

                </Paper>

            </form>
        ]
    }

    render() {
        const { classes } = this.props;

        if (!this.props.datosCierreSemanal.cajaIDgeneral === undefined) {
            return (<div></div>);
        }

        const totalMaquinas = this.props.centroDiaSelected.isSemanaCerrada ? this.props.datosCierreSemanal.totalEurosMaq : this.props.datosCierreSemanal.totalEurosMaqSinMult

        return (
            <div className={classes.root}>
                <Paper className={classes.paperConcepto} elevation={0}>
                    <Typography variant="subtitle1" className={classes.titleIngresos}>Arcade</Typography>
                    <div className={classes.containeritems}>
                        {this.renderItem("Total maquinas", totalMaquinas)}
                        {this.renderItem("Billares semana", this.props.datosCierreSemanal.totalBillares)}
                        {this.renderItem("Arcade semana", totalMaquinas - this.props.datosCierreSemanal.totalBillares)}
                        {this.renderItem("Maq. cambios", this.props.datosCierreSemanal.totalCambio)}
                        {this.renderItem("Maq. cambios compl.", this.props.datosCierreSemanal.totalEurosMaq - this.props.datosCierreSemanal.totalBillares - this.props.datosCierreSemanal.totalCambio)}
                        {this.renderBanco()}
                    </div>
                </Paper>
            </div>
        );
    };
};


CierreSemanalArcade.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //isSemanaCerrada: PropTypes.bool.isRequired,
    datosCierreSemanal: PropTypes.object.isRequired,
    //dispatch
    modifyArqueo: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    //parameters

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        //isSemanaCerrada: state.datosCierreSemanal.semanaCerrada,
        datosCierreSemanal: state.datosCierreSemanal.datos,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyArqueo,
        openDialog,
        modifyBanco2
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalArcade));